<div id="IdentifyPopupComponent" #popupRef>
  <p class="p-margin">
    {{ 'POPUP.IDENTIFY.RESULT' | translate }}:<b>{{ identifiedFeatures?.length }}</b>
  </p>
  <ol class="esri-popup__feature-menu-list ol-margin ol-padding" role="menu">
    <li
      *ngFor="let result of identifiedFeatures"
      role="menuitem"
      class="esri-popup__feature-menu-item row-container"
      (click)="rowClick(result)"
      (mouseenter)="rowEnter(result)"
      (mouseleave)="rowLeave(result)"
    >
      <span class="esri-popup__feature-menu-title title-label"> {{ result?.popUpInfo?.title | translate }}: </span>
      <span class="esri-popup__feature-menu-title info-content">
        {{ result?.displayIdentifyInfo }}
      </span>
    </li>
  </ol>
</div>
